import { useEffect, useState } from 'react';
import { studioApi } from '@/lib/studioApi';

// Asks the server whether the design contains customer AI images (assistant / guided) that carry the AI surcharge.
export const useAiSurcharge = (objects, disabled) => {
  const ids = disabled ? '' : [...new Set(objects.filter(o => o.type === 'image' && o.visible !== false && o.assetId).map(o => o.assetId))].sort().join(',');
  const [state, setState] = useState({ charged: false, cents: 0, label: '' });
  useEffect(() => {
    if (!ids) { setState(s => s.charged ? { ...s, charged: false } : s); return; }
    let alive = true;
    const t = setTimeout(() => studioApi('/ai-surcharge/check', { method: 'POST', body: { asset_ids: ids.split(',') } }).then(r => alive && setState(r)).catch(() => {}), 400);
    return () => { alive = false; clearTimeout(t); };
  }, [ids]);
  return state.charged ? state : null;
};
